import withUser from '~lib/common/hoc/withUser';

import CaseScenario from './CaseScenario.vue';

export default withUser()(CaseScenario);
